/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * WordPress dependencies
 */
import {
	ToggleGroupControl,
	ToggleGroupControlOptionIcon,
} from '@safe-wordpress/components';
import { lineDashed, lineDotted, lineSolid } from '@safe-wordpress/icons';
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { contextConnect } from '../../context';
import type { StylePickerProps } from '../types';

const BORDER_STYLES = [
	{
		label: _x( 'Solid', 'text', 'nelio-ab-testing' ),
		icon: lineSolid,
		value: 'solid',
	},
	{
		label: _x( 'Dashed', 'text', 'nelio-ab-testing' ),
		icon: lineDashed,
		value: 'dashed',
	},
	{
		label: _x( 'Dotted', 'text', 'nelio-ab-testing' ),
		icon: lineDotted,
		value: 'dotted',
	},
];

function UnconnectedBorderControlStylePicker(
	{ onChange, disabled, ...restProps }: StylePickerProps,
	forwardedRef: React.ForwardedRef< unknown >
) {
	return (
		<ToggleGroupControl
			__nextHasNoMarginBottom
			__next40pxDefaultSize
			className={ clsx( { 'nab-components--disabled': disabled } ) }
			ref={ forwardedRef }
			isDeselectable
			disabled={ disabled }
			onChange={ ( value ) => {
				onChange?.( value as string | undefined );
			} }
			{ ...restProps }
		>
			{ BORDER_STYLES.map( ( borderStyle ) => (
				<ToggleGroupControlOptionIcon
					key={ borderStyle.value }
					value={ borderStyle.value }
					icon={ borderStyle.icon }
					label={ borderStyle.label }
					disabled={ disabled }
				/>
			) ) }
		</ToggleGroupControl>
	);
}

const BorderControlStylePicker = contextConnect(
	UnconnectedBorderControlStylePicker,
	'BorderControlStylePicker'
);

export default BorderControlStylePicker;
